import React, { useState } from "react";
import BoradHeader from "../BoardHeader/BoradHeader";
import HistoryItems from "./HistoryItems";
import "./Feeds.scss";
import { useBoardName } from "../../../../utils/reactQuery/boards";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../../hooks/useResponsive";
import OpenCardDetail from "../Kanban/openCardDetail";
import { useParams } from "react-router-dom";
import SelectDatePicker from "../../../../pages/myTask/components/Filters/SelectDatePicker";

const Feeds = ({ showCardPopup = false }) => {
  const { id } = useBoardIdByKey();
  const { boardName } = useBoardName(id);
  const [loading, setLoading] = useState(false);
  const ownerId = boardName?.data?.data?.responseData?.owner_user_id;
  const workflowId = boardName?.data?.data?.responseData?.workflow_id;
  const [milestone] = useCustomSearchParams("milestone");
  const isMobile = useResponsive("down", "md");
  const { cardId } = useParams();

  const marginTopClass = milestone
    ? isMobile
      ? "mt-0"
      : "mt-185" 
    : isMobile
    ? "mt-0"
    : "mt-115";
      
  return (
    <>
      {showCardPopup && <OpenCardDetail card={cardId.split("-")[1]} />}
     <BoradHeader
        boardName={boardName?.data}
        boardId={id}
        ownerId={ownerId}
        workflowId={workflowId}
        setLoading={setLoading}
      />
      
      <div className={marginTopClass + " feeds-content-div"}>
        <div className="d-flex justify-content-space-between mb-4 ">
          <div className="d-flex">
            <p className="heading-feeds-tab mr-32">Feeds</p>
          </div>
          <div className="ml-3 d-flex align-items-center">
            <SelectDatePicker />
          </div>
        </div>
        
        {/* Scrollable content area */}
        {/* <div className="feeds-scroll">
          <HistoryItems />
        </div> */}
        <div className={`feeds-scroll ${milestone ? 'feeds-scroll-milestone' : 'feeds-scroll-no-milestone'}`}>
  <HistoryItems />
</div>
      </div>
    </>
  );
};

export default Feeds;
